import { OrderStatus, PricelistOffersGetByIdOffers, PricelistOffersGetByIdPayload, StatusOfOffer } from "../../../../services/orders/pricelist-offers-get-by-id/types";
import { getMessageOfErrorsDebugUnlogedClient, getNumberOfErrorsDebugUnlogedClient, OfferViewComponent, StatusChandleDataResponse } from "./types";

export const statusChandleData=(data:PricelistOffersGetByIdPayload):StatusChandleDataResponse=>{
    let response:StatusChandleDataResponse={
        view: OfferViewComponent.firstView,
        data: data.oferty
    }
    let readyOffers: PricelistOffersGetByIdOffers[]=[];
    let firstViewOffers:PricelistOffersGetByIdOffers[]=[];
    let resignationOffer:PricelistOffersGetByIdOffers[]=[];
    let secondOfferZeroStatusOfferSix:PricelistOffersGetByIdOffers[]=[];
    let secondOfferThreeStatusOfferSix:PricelistOffersGetByIdOffers[]=[];

    if(data.status_zamowienia===OrderStatus.Nowe){
        data.oferty.map((offer, index) => (
            (      offer.status_oferty===StatusOfOffer.nowa 
                || offer.status_oferty===StatusOfOffer.konsultowana
                || offer.status_oferty===StatusOfOffer.brak)
            ?(
                firstViewOffers.push(offer)
            )
            :(
                offer.status_oferty===StatusOfOffer.gotowa 
                ? secondOfferZeroStatusOfferSix.push(offer)
                :null
            )
        ));
        if(secondOfferZeroStatusOfferSix.length>0){
            response ={
                view: OfferViewComponent.firstView,
                data: secondOfferZeroStatusOfferSix
            }
        }else{
            response ={
                view: OfferViewComponent.firstView,
                data: firstViewOffers
            } 
        }
    };
    if(data.status_zamowienia===OrderStatus.Wstepna_akceptacja){
        data.oferty.map((offer, index) => (
            (offer.status_oferty===StatusOfOffer.gotowa)
            ?(
                readyOffers.push(offer)
            )
            :null
        ));
    if(readyOffers.length >0){
        response ={
            view: OfferViewComponent.theOfferForThisOrderHasAlreadyBeenPreApproved,
            data: readyOffers
        } 
    } 
    else{
        response ={
            view: OfferViewComponent.firstView,
            data: data.oferty
        } 
    }
   
    };
    if(data.status_zamowienia===OrderStatus.Rezygnacja){
        data.oferty.map((offer, index) => (
            ( offer.status_oferty===StatusOfOffer.gotowa)
            ?(
                secondOfferThreeStatusOfferSix.push(offer)
            )
            :(
                (offer.status_oferty===StatusOfOffer.nowa 
                || offer.status_oferty===StatusOfOffer.konsultowana
                || offer.status_oferty===StatusOfOffer.brak
                )
                ?resignationOffer.push(offer)
                :null
            )
        )); 
        if(secondOfferThreeStatusOfferSix.length>0){
            response ={
                view: OfferViewComponent.firstView,
                data: secondOfferThreeStatusOfferSix
            } 
        }else {
            if(resignationOffer.length>0){
                response ={
                    view: OfferViewComponent.firstView,
                    data: resignationOffer
                } 
            }else{
                response ={
                    view: OfferViewComponent.theOfferForTheGivenOrderHasAlreadyBeenRejected,
                    data: resignationOffer
                } 
            }
        }
        
    };
    return response
}
export const statusChandleDataFinalOffer=(data:PricelistOffersGetByIdPayload):StatusChandleDataResponse=>{

    let response:StatusChandleDataResponse={
        view: OfferViewComponent.theOfferHasBennFinallyAcceptedOrThereIsNoOfferForFinalAcceptance,
        data: []
    }
    let finalOffer: PricelistOffersGetByIdOffers[]=[];

    if(data.status_zamowienia===OrderStatus.Do_ostatecznej_akceptacji){
        data.oferty.map((offer, index) => (
            (offer.status_oferty===StatusOfOffer.gotowa)
            ?(
                finalOffer.push(offer)
            )
            :null
        ));
    };
    if(finalOffer.length !==0){
        
        response ={
            view: OfferViewComponent.finalOffertView,
            data: finalOffer
        } 
    } 
    return response

}
export const mesageErrorDebugUnloggedClient=(errors_debug:string):string=>{
return getMessageOfErrorsDebugUnlogedClient(getNumberOfErrorsDebugUnlogedClient(errors_debug))
}